/** Read-only summary of the scanned member (PosScanResult). */
import type { Brand, PosScanResult } from "../api-types";
import { h } from "../dom-helpers";
import { strings } from "../strings";

function stat(label: string, value: string, testId: string): HTMLElement {
  return h("div", { className: "stat" }, h("span", { className: "stat-label" }, label), h("strong", { "data-testid": testId }, value));
}

export function renderMemberSummary(member: PosScanResult, brands: Brand[]): HTMLElement {
  const brandName = (id: string) => brands.find((b) => b.id === id)?.name ?? id;
  const coupons = member.availableCoupons;
  const pack = member.ownedPack;
  const reservation = member.reservation;
  const reservedCoupon = reservation ? coupons.find((c) => c.id === reservation.couponId) : undefined;

  return h(
    "section",
    { className: "card stack", "aria-label": member.displayName },
    h("h2", { "data-testid": "member-name" }, member.displayName),
    h(
      "div",
      { className: "stats" },
      stat(strings.memberTier, strings.tierName[member.tier], "member-tier"),
      stat(strings.memberPoints, strings.points(member.points), "member-points"),
      stat(strings.memberIsic, member.isicVerified ? strings.memberIsicYes : strings.memberIsicNo, "member-isic"),
    ),
    reservation
      ? h("p", { className: "notice" }, `${strings.memberReservation}: ${reservedCoupon?.title ?? reservation.couponId}`)
      : null,
    pack ? h("p", {}, `${strings.memberPack}: ${strings.memberPackProgress(pack.used, pack.meals, pack.validUntil)}`) : null,
    h("h3", {}, strings.memberCoupons),
    coupons.length === 0
      ? h("p", { className: "muted" }, strings.memberNoCoupons)
      : h(
          "ul",
          { className: "coupons" },
          ...coupons.map((c) =>
            h("li", {}, h("span", { className: "chip" }, c.value), ` ${c.title} `, h("span", { className: "muted" }, `· ${brandName(c.brandId)} · ${c.condition}`)),
          ),
        ),
  );
}
